import { render } from "./SVGResizeH.vue?vue&type=template&id=24cc0f8c"
import script from "./SVGResizeH.vue?vue&type=script&lang=js"
export * from "./SVGResizeH.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__